import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import idTranslations from './locales/id.json';
import enTranslations from './locales/en.json';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from '../config/constants';

const resources = {
  [SUPPORTED_LANGUAGES.ID]: {
    translation: idTranslations,
  },
  [SUPPORTED_LANGUAGES.EN]: {
    translation: enTranslations,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    lng: DEFAULT_LANGUAGE,
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;